import { ComponentRef, Injectable, Type, ViewContainerRef } from '@angular/core';

import DOMPurify from 'dompurify';

@Injectable({ providedIn: 'root' })

export class HTMLRendererUtilityService {
    sanitizeNoteHtml(content: string): string {
        return DOMPurify.sanitize(content ?? '', {
            FORBID_TAGS: ['script', 'iframe', 'frame', 'object', 'embed', 'form'],
        });
    }

    createComponentElement<T>(
        component: Type<T>,
        vcr: ViewContainerRef,
        inputs?: Partial<T>
    ): { element: HTMLElement, compRef: ComponentRef<T>; } {
        const compRef: ComponentRef<T> = vcr.createComponent(component);

        if (inputs) {
            Object.assign(compRef.instance, inputs);
        }

        compRef.changeDetectorRef.detectChanges();
        const container = document.createElement('div');
        container.appendChild(compRef.location.nativeElement);
        return { element: container, compRef };
    }
}

export function extractTextFromRichText(value: string): string {
    const parser = new DOMParser();
    const doc = parser.parseFromString(value, 'text/html');
    return doc.body.textContent;
}
